import React, {useEffect , useState, useRef} from 'react'
import Banner from '../Banner';
import { Link, useLocation } from "react-router-dom";
import rooms from '../../Constants/rooms';
import ReviewBox, { Review, reviewItem } from '../ReviewBox';
import { backgroundColorCounter, borderO } from '../Home/style';
import { renderRoom } from '../Rooms';
import PageNotFound from '../../Layouts/PageNotFound';
import $ from 'jquery';
import Sticky from 'sticky-js';
import { Swiper, SwiperSlide } from "swiper/react";
import { useTranslation } from 'react-i18next';
import _ from 'underscore';
// Import Swiper styles
import "swiper/swiper.min.css";
import "swiper/components/navigation/navigation.min.css"
import "swiper/components/thumbs/thumbs.min.css"
import{ init, send } from 'emailjs-com';
import emailkey from '../../emailkey';

// import Swiper core and required modules
import SwiperCore, {
  Navigation,Thumbs
} from 'swiper/core';
import { isMobileDevice } from '../../reusable';

// install Swiper modules
SwiperCore.use([Navigation,Thumbs]);

const services =  [
    {title: 'yard', image: 'assets/img/services/4.jpg'},
    {title: 'restaurant', image: 'assets/img/services/2.jpg'},
    {title: 'snackbar', image: 'assets/img/services/3.jpg'},
]

const reviews =  [
    {author: {name : 'Oscar Poirier', profile : 'assets/img/faces/1.jpg'}, date: '12.03.2021', mark : 4, review: "Très bon emplacement avec une belle vue sur le fleuve, très propre, personnel agréable. C'était très bien par rapport au prix"},
    {author: {name : 'Emmanuel Bakary', profile : 'assets/img/faces/2.jpg'}, date: '14.05.2021', mark : 5, review: "Rapport qualité-prix imbattable, le  service impécable et le lieux est très propre. ma destination par excellence lors de mes voyages d'affaire au Cameroun."},
    {author: {name : 'Viktoria Freeman', profile : 'assets/img/faces/3.jpg'}, date: '03.01.2021', mark : 4, review: "Cleanliness of all rooms, politeness of all staff, convenient location. I really recommend this hotel."},
    {author: {name : 'Claude Abanda', profile : 'assets/img/faces/4.jpg'}, date: '28.10.2021', mark : 5, review: "Le service à la clientèle était très bon et les gens gentils. Le lieu est vraiment agréable."},
]

interface Feature {
    title : string
    image : string
}


interface Service {
    title : string
    image : string
}


function useQuery() {
    return new URLSearchParams(useLocation().search);
}

function Room() {
    const { t, i18n } = useTranslation();
    let query = useQuery();
    let id = parseInt(''+query.get('id'));
    const room = rooms.find(item => item.id===id)
    const banner = {
        title : room?room.title[i18n.language] + ' - ' + t('main.siteName'):null,
        description : room?room.description[i18n.language]:null,
        navigation: [{title: t('main.rooms'), path: '/rooms'},{title: room?room.title[i18n.language]:null, path: ''}]
    }

    const checkIn = useRef<HTMLInputElement>(null)
    const checkOut = useRef<HTMLInputElement>(null)
    const person = useRef<HTMLSelectElement>(null)
    const children = useRef<HTMLSelectElement>(null)

    function showImage(image:string, index:number) {
        return(
            <SwiperSlide key={index}>
                <a data-fancybox="gallery" href={image} className="knsl-room-detail-photo-lg" data-swiper-parallax="-80" data-swiper-parallax-scale="1.2" data-swiper-parallax-duration="400">
                    <img src={image} alt={room?`${room.title[i18n.language]} ${t('main.siteName')}`:t('main.siteName')} />
                    <span className="knsl-zoom"><i className="fas fa-search-plus"></i></span>
                </a>
            </SwiperSlide>
        )
    }

    function showThumbnail(image:string, index:number) {
        return(
            <SwiperSlide key={index}>
                <div className="knsl-room-detail-photo-sm">
                    <img src={image} alt={room?room.title[i18n.language]:t('main.siteName')} />
                </div>
            </SwiperSlide>
        )
    }

    function featureItem(feature:Feature, index:number) {
        return(
            <div key={index} className="col-6 col-md-3">
                <div className="knsl-icon-box knsl-icon-box-sm knsl-scroll-animation">
                    <img src={feature.image} alt={feature.title} className="knsl-mb-10" />
                    <h5>{t(`main.${feature.title}`)}</h5>
                </div>
            </div>
        )
    }

    function serviceItem(service:Service, index:number) {
        return(
            <div key={index} className="col-lg-4">
                <div className="knsl-ath-card knsl-scroll-animation">
                    <div className="knsl-cover-frame">
                        <img src={service.image} alt={t(`main.${service.title}`)} />
                    </div>
                    <div className="knsl-card-description">
                        <h5>{t(`main.${service.title}`)}</h5>
                    </div>
                </div>
            </div>
        )
    }
    
    const [thumbsSwiper, setThumbsSwiper] = useState<any | null>(null);

    function submitReview (name: string, email: string, text : string) {
        let message = {name, email, text}
        init(emailkey.USER_ID);
        send(emailkey.SERVICE_ID, emailkey.TEMPLATE_ID, message, emailkey.USER_ID)
        .then((result: any) => {
            console.log("Message Sent, We will get back to you shortly", result.text);
        },
        (error: any) => {
            console.log("An error occurred, Please try again", error.text);
        });
    }

    const goToTop = () => window.scrollTo(0, 0);

    useEffect(() => {
        goToTop();
        let sticky = new Sticky('.knsl-sticky');
        if ($(window).width() < 992) {
            sticky.destroy();
        }
    }, []);

    function generateUrl() {
        let url = t('main.IWantToReserveARoomFor')
        if(person.current)
            url += person.current.value + t('main.persons')
        if(children.current && children.current.value!=="0")
            url += t('main.and') + children.current.value + t('main.children')
        if(checkIn.current && checkOut.current)
            url += t('main.FromThe') + checkIn.current.value + t('main.to') + checkOut.current.value
        return url
    }

    if(room)
        return (
            <>
                <Banner data={banner}/>
                {/* <!-- room --> */}
                <div className="knsl-p-100-100">
                    <div className="container">
                        <div className="row" data-sticky-container>
                            <div className="col-lg-8">
                                <div className="knsl-room-detail-slider-frame knsl-mb-60">
                                    <div className="swiper-container knsl-rd-slider-2 knsl-mb-10">
                                        <Swiper 
                                            loop
                                            effect={'fade'}
                                            parallax
                                            thumbs={{swiper: thumbsSwiper}}>
                                            {room.images.map((item:string,index) => showImage(item,index))}
                                        </Swiper>
                                    </div>
                                    <div className="swiper-container  knsl-rd-slider-1">
                                        <Swiper 
                                            onSwiper={(swiper) => setThumbsSwiper(swiper)}
                                            loop
                                            spaceBetween={10}
                                            slidesPerView={4}
                                            freeMode
                                            watchSlidesVisibility
                                            watchSlidesProgress={true}>
                                            {room.images.map((item:string,index) => showThumbnail(item,index))}
                                        </Swiper>
                                    </div>
                                </div>

                                <section className="knsl-mb-60 knsl-scroll-animation">
                                    <h3 className="knsl-mb-40">{room.desc.title[i18n.language]}</h3>
                                    <p>{room.desc.content[i18n.language]}</p>
                                </section>

                                <section>
                                    <div className="row">
                                        <div className="col-lg-12">
                                            <h3 className="knsl-mb-40 knsl-scroll-animation">{t('main.location')}</h3>
                                        </div>
                                        <div className="col-lg-12">
                                            <div className="knsl-map-frame knsl-mb-60">
                                                <div className="knsl-lock"><i className="fas fa-lock"></i></div>
                                                <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15920.218136882184!2d9.6989784!3d4.00921!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x2f6e7ba336dafeaf!2sThe%20west%20Heaven!5e0!3m2!1sfr!2scm!4v1630557896864!5m2!1sfr!2scm" width="800" height="350" style={borderO} allowFullScreen loading="lazy" title="The West Heaven Hotel"></iframe>
                                            </div>
                                        </div>
                                    </div>
                                </section>


                                <section className="knsl-mb-60">
                                    <div className="row">
                                        <div className="col-lg-12">
                                            <h3 className="knsl-mb-40 knsl-scroll-animation">{t('main.amenity')}</h3>
                                        </div>
                                        {room.features.map((feature:Feature,index) => featureItem(feature,index))}
                                    </div>
                                </section>

                                <section className="knsl-mb-30">
                                    <div className="row">
                                        <div className="col-lg-12">
                                        <h3 className="knsl-mb-40 knsl-scroll-animation">{t('main.aroundHotel')}</h3>
                                        </div>
                                        {services.map((service:Service,index) => serviceItem(service,index))}
                                    </div>
                                </section>

                                <section className="knsl-mb-30">
                                <div className="row">
                                    <div className="col-lg-12">
                                        <h3 className="knsl-mb-40 knsl-scroll-animation">{t('main.reviews')}</h3>
                                    </div>
                                    { _.sample(reviews, 2).map((review:Review,index) => reviewItem(review,index))}
                                </div>
                                </section>

                                <ReviewBox onSubmit={submitReview} end='takeAReservation' long />

                            </div>

                            <div className="col-lg-4">
                                {/* <!-- sidebar --> */}
                                <div className="knsl-sticky knsl-stycky-right" data-margin-top="100">

                                    {/* <!-- room info --> */}
                                    <div className="knsl-room-features-lg knsl-mb-20">
                                        <div className="knsl-feature">
                                        <div className="knsl-icon-frame"><img src="assets/img/icons/bed.svg" alt="icon" /></div>
                                        <span>{room.guest} {t('main.guests')}</span>
                                        </div>
                                        <div className="knsl-feature">
                                        <div className="knsl-icon-frame"><img src="assets/img/icons/square.svg" alt="icon" /></div>
                                        <span>{room.size} Ft²</span>
                                        </div>
                                    </div>
                                    {/* <!-- room info end --> */}

                                    <div className="knsl-price-card knsl-mb-20">
                                        <div className="knsl-price-number">{room.price} Xaf<span>/{t('main.night')}</span></div>
                                        <a className="knsl-btn" href={ isMobileDevice() ? 'https://wa.me/237652726390?text='+t('main.iWantToReserve')+room.title.en:"#review2" }  >{t('main.reservation')}</a>
                                    </div>

                                    <div className="knsl-book-form">
                                        <form>
                                            <div className="row">
                                                <div className="col-lg-12">
                                                    <div className="knsl-input-frame">
                                                        <label htmlFor="check-in">{t('main.checkIn')}</label>
                                                        <input id="check-in" ref={checkIn} type="text" className="datepicker-here" data-position="bottom left" placeholder="Select date" autoComplete="off" readOnly />
                                                    </div>
                                                </div>
                                                <div className="col-lg-12">
                                                    <div className="knsl-input-frame">
                                                        <label htmlFor="check-out" className="knsl-add-icon">{t('main.checkOut')}</label>
                                                        <input id="check-out" ref={checkOut} type="text" className="datepicker-here" data-position="bottom left" placeholder="Select date" autoComplete="off" readOnly />
                                                    </div>
                                                </div>
                                                <div className="col-6">
                                                    <div className="knsl-select-frame">
                                                        <label htmlFor="person">{t('main.person')}</label>
                                                        <select className="nice-select" ref={person}>
                                                            <option value="1">1</option>
                                                            <option value="2">2</option>
                                                            <option value="3">3</option>
                                                            <option value="4" disabled>4</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-6">
                                                    <div className="knsl-select-frame">
                                                        <label htmlFor="children">{t('main.children')}</label>
                                                        <select className="nice-select"  ref={children}>
                                                            <option value="1">1</option>
                                                            <option value="2">2</option>
                                                            <option value="3">3</option>
                                                            <option value="4" disabled>4</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-lg-12 knsl-center">
                                                    <a href={ isMobileDevice() ? generateUrl():"#review2"} className="knsl-btn"><img src="assets/img/icons/search.svg" className="knsl-zoom" alt="icon" />{t('main.searchRoom')}</a>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                                {/* <!-- sidebar end --> */}
                            </div>
                        </div>
                    </div>
                </div>
                {/* <!-- room end --> */}

                {/* <!-- rooms --> */}
                <section className="knsl-transition-top knsl-p-0-80" style={backgroundColorCounter}>
                    <img src="assets/img/palm.svg" className="knsl-deco-left" alt="palm" />
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-lg-12">
                                <div className="knsl-center knsl-title-frame knsl-scroll-animation knsl-mb-100">
                                    <h2 className="knsl-mb-20">{t('main.similarRooms')}</h2>
                                    <p className="knsl-mb-30">{t('main.chooseYourRoomDesc')}</p>
                                    <Link to="/rooms" className="knsl-btn knsl-btn-md">{t('main.allRooms')}</Link>
                                </div>
                            </div>
                            <div className="row">
                                {rooms.filter(room => !room.title.en.includes('+')).map(item => <div className='col-sm-4' key={item.id}> {renderRoom(item, goToTop,{guests: t('main.guests'),night : t('main.night'),book : t('main.bookNow')}, i18n.language)} </div>)}
                            </div>
                            
                        </div>
                    </div>
                </section>
                {/* <!-- rooms end --> */}
            </>
        );
    else
        return <PageNotFound />
}

export default Room